<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class="card-header border-bottom p-1 d-flex justify-content-start flex-wrap"
            >
              <div
                class="btn-group m-1"
                role="group"
                data-toggle="buttons"
                v-for="master in masters"
              >
                <button
                  class="btn btn-primary font-weight-bold border btn-outline-primary h5 mb-0 p-1 pl-3 pr-3"
                  :class="{
                    active: selectedView === master,
                    border: selectedView === master
                  }"
                  @click="selectedView = master"
                  type="button"
                >
                  {{ master.name }}
                </button>
              </div>
            </div>
            <div class="card-body">
              <contract-template
                v-if="selectedView.id === 1"
              ></contract-template>
              <user-contract v-if="selectedView.id === 2"></user-contract>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractTemplate from './ContractTemplate.vue'
import UserContract from './UserContract.vue'
export default {
  components: {
    ContractTemplate,
    UserContract
  },
  data() {
    return {
      buttonApplicationLetterUrl: 'SettingsApplicationLetter',

      selectedView: {},
      masters: [
        {
          id: 1,
          name: 'Planilla - Carta de Solicitud'
        },
        {
          id: 2,
          name: 'Cartas de Agremiados'
        }
      ]
    }
  },
  methods: {
    goApplicationLetter() {
      this.$router.push({ name: this.buttonApplicationLetterUrl })
    }
  },
  mounted() {
    this.selectedView = this.masters[0]
  }
}
</script>

<style>
.text-title-dashboard {
  color: #30476c;
}
tr:last-child td {
  border-bottom: 1px solid #dee2e6; /* Asegúrate de que la última fila tenga un borde inferior */
}
.btn-settings {
  background-color: #2f4a93;
  color: white;
  border-radius: 12px;
  height: 90px;
  border: none;
  font-size: 20px;
}
.btn-settings:hover {
  background-color: #0d2a57;
}
</style>
